const DEFAULT_MAX = 100;

export const getRandomNumber = (lowerBoundary = 0, upperBoundary = DEFAULT_MAX): number =>
    Math.floor(Math.random() * (upperBoundary - lowerBoundary + 1)) + lowerBoundary;
